import React, { useMemo, useState } from "react";
import "./weChatCommon.scss";
import "./weChatPasswordComponent.scss";
import {
  clearWeChatContext,
  getWeChatContext,
  getWeChatLoginEmail,
} from "../../utils/weChatContext.utils";
import config from "../../constants/config";
const { ENV_SUFIX } = config;

const BIND_URL = "/api-gateway/identity-wechat/identity/wechat/auth/bind";
const WECHAT_MOBILITY_URL = "/wechat/user";
const getWeChatMobilityUrl = () =>
  process.env[`REACT_APP_WECHAT_MOBILITY_URL${ENV_SUFIX}`] ||
  WECHAT_MOBILITY_URL;

const getInitialEmail = () => {
  if (typeof window === "undefined") return "";

  return (
    window.emailAdd ||
    getWeChatLoginEmail() ||
    ""
  );
};

const getRegTokenFromUrl = () => {
  if (typeof window === "undefined") return "";

  return new URLSearchParams(window.location.search || "").get("regToken") || "";
};

const getProviderUidFromUrl = () => {
  if (typeof window === "undefined") return "";
  return new URLSearchParams(window.location.search || "").get("providerUid") || "";
};

function WeChatPasswordComponent() {
  window?.tfIdentityGlobals?.hideLoader();
  const queryParams = useMemo(() => getWeChatContext(), []);
  const regToken = useMemo(
    () => getRegTokenFromUrl() || queryParams.regToken || "",
    [queryParams.regToken]
  );
  const providerUid = useMemo(
    () => getProviderUidFromUrl() || queryParams.providerUid || "",
    [queryParams.providerUid]
  );
  const [emailAdd] = useState(getInitialEmail);
  const [password, setPassword] = useState("");
  const [pwdErrorMessage, setPwdErrorMessage] = useState("");
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [passwordDisabled, setPasswordDisabled] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const showError = (element, msg) => {
    if (element === "wechat-pwd-error") {
      setPwdErrorMessage(msg);
    }
  };

  const disableSubmit = () => {
    setSubmitDisabled(true);
  };

  const enableSubmit = () => {
    setSubmitDisabled(false);
  };

  const checkSubmit = (nextPassword) => {
    if (nextPassword.length === 0) {
      disableSubmit();
    } else {
      enableSubmit();
    }
  };

  const logAuditData = (action, message, responseData, country) => {
    if (
      typeof window !== "undefined" &&
      typeof window.logAuditData === "function"
    ) {
      window.logAuditData(action, message, responseData, country);
    }
  };

  const userLogin = async () => {
    const email = emailAdd.trim();

    if (password === "") {
      showError("wechat-pwd-error", "密码为必填项");
      disableSubmit();
      return;
    }

    if (!regToken || !providerUid) {
      showError(
        "wechat-pwd-error",
        "Unable to continue. Please restart WeChat sign in."
      );
      disableSubmit();
      return;
    }

    const data = {
      password,
      regToken,
      username: email,
      providerUid,
    };

    setIsSubmitting(true);

    try {
      const httpResponse = await fetch(BIND_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (httpResponse.status !== 200) return;

      const response = await httpResponse.json();
      const responseDetails = response.data || {};
      const responseData = {
        errorCode: responseDetails.errorCode,
        errorMessage: responseDetails.errorMessage,
        UID: responseDetails.uid || queryParams.UID,
        user: {
          email,
        },
      };
      if (responseDetails.errorCode == "200009") {
        const redirectUid = responseDetails.uid || queryParams.UID;

        logAuditData("WeChat Login", "Account Linked", responseData, "China");
        clearWeChatContext();
      console.log("WeChat Login Response:", getWeChatMobilityUrl(), redirectUid);
        window.location.href = `${getWeChatMobilityUrl()}?UID=${encodeURIComponent(
          redirectUid
        )}`;
      } else if (responseDetails.errorCode == "403042") {
        logAuditData(
          "WeChat Login",
          "Account Linking Failed",
          responseData,
          "China"
        );
        showError("wechat-pwd-error", "密码错误");
      } else if (responseDetails.errorCode == "699999") {
        logAuditData(
          "WeChat Login",
          "Account Linking Failed",
          responseData,
          "China"
        );
        showError(
          "wechat-pwd-error",
          "此邮箱已被其他用户绑定,请发邮件至mobilitychina@thermofisher.com获取更多帮助."
        );
        disableSubmit();
        setPasswordDisabled(true);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const isSubmitDisabled = submitDisabled || isSubmitting;

  return (
    <div
      id="gigya-link-account-screen"
      data-width="auto"
      data-caption="Account Linking"
      className="gigya-screen v2 gigya-link-account-screen portrait gigya-composite-control-active we-chat-password-component"
    >
      <div className="gigya-link-accounts-form" id="gigya-link-accounts-form">
        <div id="we-chat-tabs">
          <div id="we-chat-signIn-tab">
            <button
              type="button"
              className="gigya-composite-control gigya-composite-control-link we-chat-active"
              data-toolbox-item-type="link"
              data-binding="true"
              data-wizard-base-translation-key="LINK_140325667860465580"
            >
              登录
            </button>
            <span className="we-chat-signIn-pointer"></span>
          </div>
          <div id="we-chat-signUp-tab">
            <button
              type="button"
              className="gigya-composite-control gigya-composite-control-link"
              data-toolbox-item-type="link"
              data-binding="true"
              data-wizard-base-translation-key="LINK_33011936696667540"
            >
              注册
            </button>
            <span className="we-chat-signUp-pointer"></span>
          </div>
        </div>

        <div className="gigya-layout-row">
          <div className="gigya-layout-cell with-social-login responsive ui-droppable ui-sortable">
            <div
              data-login-identities="site"
              className="gigya-composite-control gigya-composite-control-textbox gigya-conditional we-chat-email-field"
              data-toolbox-item-type="textbox"
              data-wizard-base-translation-key="TEXTBOX_9521252200460624"
            >
              <label
                className="gigya-label"
                htmlFor="we-chat-email-input"
                data-binding="true"
              >
                <span className="gigya-label-text">邮箱</span>
                <span
                  className="gigya-required-display we-chat-required"
                  data-bound-to="loginID"
                >
                  *
                </span>
              </label>
              <input
                type="text"
                placeholder="请输入邮箱 *"
                data-gigya-placeholder="请输入邮箱"
                name="loginID"
                className="gigya-input-text"
                formNoValidate
                disabled
                readOnly
                data-array-root=""
                data-gigya-type="text"
                id="we-chat-email-input"
                value={emailAdd}
              />
              <span className="gigya-error-msg" data-bound-to="loginID"></span>
            </div>
          </div>
        </div>

        <div className="gigya-layout-row">
          <div className="gigya-layout-cell responsive ui-droppable ui-sortable">
            <div
              data-login-identities="site"
              className="gigya-composite-control gigya-composite-control-password gigya-conditional we-chat-password-field"
              data-toolbox-item-type="password"
              data-wizard-base-translation-key="PASSWORD_112529999536342910"
            >
              <label
                className="gigya-label"
                htmlFor="we-chat-pwd-input"
                data-binding="true"
              >
                <span className="gigya-label-text">密码</span>
                <span
                  className="gigya-required-display we-chat-required"
                  data-bound-to="password"
                >
                  *
                </span>
              </label>
              <input
                type="password"
                placeholder="请输入您的密码"
                data-gigya-placeholder="请输入您的密码"
                name="password"
                className={`gigya-input-password${
                  passwordDisabled ? " disabled-field" : ""
                }`}
                data-array-root=""
                autoComplete="off"
                id="we-chat-pwd-input"
                value={password}
                disabled={passwordDisabled}
                onChange={(event) => {
                  const nextPassword = event.target.value;

                  setPassword(nextPassword);
                  setPwdErrorMessage("");
                  checkSubmit(nextPassword);
                }}
              />
            </div>
          </div>
        </div>

        <span
          className={`gigya-error-msg${
            pwdErrorMessage ? " gigya-error-msg-active" : ""
          }`}
          data-bound-to="password"
          id="wechat-pwd-error"
        >
          {pwdErrorMessage}
        </span>

        <div className="gigya-layout-row">
          <div className="gigya-layout-cell with-site-login responsive">
            <div className="gigya-layout-row ui-droppable ui-sortable">
              <div
                data-login-identities="site"
                className="gigya-composite-control gigya-composite-control-submit gigya-conditional"
                data-toolbox-item-type="submit"
                data-wizard-base-translation-key="SUBMIT_36585504925953250"
              >
                <input
                  type="button"
                  className={isSubmitDisabled ? "disabled-btn" : ""}
                  disabled={isSubmitDisabled}
                  value="登录"
                  id="we-chat-submit"
                  onClick={userLogin}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeChatPasswordComponent;
